import store from '../../store/configureStore';

export default class ViewSettings {
  constructor(initializer = {}) {
    Object.assign(this, initializer);
  }
  static get ACTIONS() {
    return {
      UPDATE_VIEW_SETTINGS: 'UPDATE_VIEW_SETTINGS',
    };
  }
  static updateSettings(viewSettings) {
    store.dispatch({
      type: ViewSettings.ACTIONS.UPDATE_VIEW_SETTINGS,
      viewSettings
    })
  }
  static reducer(state = {}, action) {
    switch (action.type) {
      case ViewSettings.ACTIONS.UPDATE_VIEW_SETTINGS: {
        let viewSettings = new ViewSettings(action.viewSettings);
        return viewSettings;
      }
      default: return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/settings/index.js